import { Injectable } from '@angular/core';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountExternalUserService extends BaseService {
  protected baseUrl = '/personal-account/security/external-user';

  public findWithPagination(
    queryParams: DropdownBaseQueryInterface
  ): Observable<PaginationFindInterface<ExternalUserFindInterface>> {
    return this.http.get<PaginationFindInterface<ExternalUserFindInterface>>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
